import { UnitModel } from '../../types';
import api from '../../utils/api';
import { omit } from 'lodash/fp';

export const updateUnitModel = (variables: UnitModel) =>
  api.put({
    url: `/unit-model/${variables.id}`,
    variables: omit(['id'], variables),
  });
